import { DrawerEvent } from "@quote/quote/eventEnums";
import { useEffect, useState } from "react";

import { useCsrfToken } from "@/hooks";

import styles from "./QuoteDrawer.module.css";
import App from "./app";

const QuoteDrawer = () => {
  const [closing, setClosing] = useState(false);
  const [packageId, setPackageId] = useState<number | null>(null);

  useCsrfToken();

  const close = () => {
    setClosing(true);
  };

  useEffect(() => {
    const eventHandler = (e: MessageEvent) => {
      const { eventType, event } = e.data ?? {};
      if (!eventType) {
        return;
      }

      if (eventType === DrawerEvent.EXIT) {
        close();
      }

      if (eventType === DrawerEvent.OPEN_DRAWER && event?.packageId) {
        const newPackageId = parseInt(event.packageId, 10);
        if (!isNaN(newPackageId)) {
          setPackageId(newPackageId);
        }
      }
    };

    window.addEventListener("message", eventHandler);

    return () => {
      window.removeEventListener("message", eventHandler);
    };
  }, []);

  return (
    <div className={styles.drawer} data-visibility={!!packageId}>
      <div className={styles.overlay} onClick={close} data-closing={closing} />
      <div
        id="drawer-content"
        className={styles.drawerContent}
        onAnimationEnd={() => {
          if (closing) {
            setPackageId(null);
            setClosing(false);
          }
        }}
        data-closing={closing}
      >
        {packageId ? <App packageId={packageId} /> : <div>❗Error...</div>}
      </div>
    </div>
  );
};

export default QuoteDrawer;
